import { PlayCircle } from "lucide-react";
import { assetUrl } from "@/lib/api";

const embed = (url) => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
};

export const VideoBox = ({ url, className = "" }) => {
  const src = url ? embed(url) : null;
  return (
    <div className={`relative aspect-video bg-ink2 overflow-hidden ${className}`} data-testid="ways-video-box">
      {!url ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-shell/60" data-testid="ways-video-empty">
          <img src="/images/doodle-overlay.png" alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <PlayCircle className="relative w-14 h-14 text-tang" />
          <p className="relative text-sm">Video coming soon</p>
        </div>
      ) : src ? (
        <iframe src={src} title="MAS Arts video" className="absolute inset-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="ways-video-iframe" />
      ) : (
        <video src={assetUrl(url)} controls playsInline className="absolute inset-0 w-full h-full object-cover bg-black" data-testid="ways-video-player" />
      )}
    </div>
  );
};
